import { Serializers, SerializerValue } from "@megaron/serializers";

export const regionProfitMetricsFiltersSerializer = Serializers.object({
  startDate: Serializers.month,
  endDate: Serializers.month,
}).partial();

export type RegionProfitMetricsFilters = SerializerValue<typeof regionProfitMetricsFiltersSerializer>;
